import styled from 'styled-components';

import { Bar } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

export const IdShape = styled(Bar)`
    grid-area: id;
`;
export const TitleShape = styled(Bar)`
    grid-area: title;
`;
export const StatusShape = styled(Bar)`
    grid-area: status;
    margin-left: auto;
`;
